import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadObject } from '../../../_core/state/asset/asset.service';

import { environment } from '../../../../environments/environment';
import { Project, ProjectsQuery } from '../../../_core/state/project';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { SessionQuery } from '../../../_core/state/session';

import { Type as AssetCategory } from '../../../../../../api/src/asset/asset.entity';
import { Business, BusinessQuery } from '../../../_core/state/business';
import { Observable } from "rxjs";
import { GlobalSettings } from "../../../_core/state/global/global.model";
import { GlobalQuery, GlobalService } from "../../../_core/state/global";
import { FileUploadService } from '../../services/file-upload.service';

@Component({
	selector: 'app-file-uploader',
	templateUrl: './file-uploader.component.html',
	styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {
	@Input('assetCategory') assetCategory: AssetCategory | undefined;
	@Input() showDoneButton = true;
	@Input() hideDropAreaAfterFilesAdded = true;
	@Output('isDone') isDone: EventEmitter<string[]> = new EventEmitter<string[]>();
	@Input() instructions: string;
	@Input() collectionId?: string;
	@Input() automaticUpload = false;
	@Input() hideSaveToField = false;

	public isAdmin: boolean = false;
	private siteId: string = environment.organizationId;
	public project: Project | undefined;
	public business: Business | undefined;
	public userBusinesses: number;

	public files: FileUploadObject[] = [];
	public previews: any = [];

	public validationErrorMessage: string | null;
	public siteCopy$: Observable<Partial<GlobalSettings>>;
	private fileBusinessAssociationMap: Map<string, string> = new Map<string, string>();

	constructor(
		private readonly fileUploadService: FileUploadService,
		private readonly sessionQuery: SessionQuery,
		private readonly projectQuery: ProjectsQuery,
		private readonly businessQuery: BusinessQuery,
		private readonly globalQuery: GlobalQuery,
		private readonly globalService: GlobalService
	) {
		this.siteCopy$ = this.globalQuery.copy$;
	}

	ngOnInit() {
		this.isAdmin = this.sessionQuery.isAtLeastAdmin();
		this.project = this.projectQuery.getActive();
		this.business = this.project?.business ? this.project.business : this.businessQuery.getActive();
		this.userBusinesses = this.sessionQuery.getProfile()?.businesses?.length || 0;
		this.fileUploadService.files = [];

		if (!this.business) {
			this.business = this.sessionQuery.getProfile().businesses[0];
		}
	}


	public async addFile(event: any) {
		const newFiles = await this.fileUploadService.addFile(event, this.assetCategory, this.collectionId);
		this.files = this.fileUploadService.files;

		if (this.fileUploadService.validationErrorMessage) {
			this.validationErrorMessage = this.fileUploadService.validationErrorMessage;

			this.globalService.triggerCustomMessage(
				this.fileUploadService.validationErrorMessage,
				'danger'
			);
		}

		if (this.automaticUpload && newFiles?.length) {
			newFiles.forEach(file => this.upload(file));
		}
	}

	public async upload(file: FileUploadObject) {
		if (file.uploaded || file.uploading) {
			return;
		}
		file.uploading = true;

		let associatedBusinessId = this.fileBusinessAssociationMap.get(file?.id) || this.business?.id;

		this.fileUploadService.upload(file, this.siteId, this.project?.id as string, associatedBusinessId, this.collectionId ? [this.collectionId] : file.collectionIds).subscribe(
			event => {
				if (event.type === HttpEventType.UploadProgress) {
					// Track upload progress
					const total = event.total || 0;
					const loaded = event.loaded || 0;
					file.progress = total > 0 ? Math.round((loaded / total) * 100) : 0;
					file.bytesLoaded = loaded;
					file.totalBytes = total;
				} else if (event instanceof HttpResponse) {
					file.id = event?.body?.['id'];
					file.uploading = false;
					file.uploaded = true;
					file.progress = 100;
				}
			},
			async err => {
				console.log(err);
				file.uploaded = false;
				file.uploading = false;
				file.error = err?.message || 'Upload failed';
				// const toast = await this.toastController.create({
				// 	message: 'Error saving file. ' + err.message,
				// 	color: 'danger',
				// 	duration: 2000,
				// });
				// toast.present();
			}
		);
	}

	public done() {
		this.isDone.emit(this.files.filter(f => f.uploaded && f.id).map(f => f.id));
	}

	get totalFiles(): number {
		return this.files?.length ?? 0;
	}

	get uploadedCount(): number {
		return this.files?.filter(file => file.uploaded)?.length ?? 0;
	}

	get remainingCount(): number {
		return Math.max(this.totalFiles - this.uploadedCount, 0);
	}

	get automaticUploadStatusMessage(): string {
		if (!this.automaticUpload || !this.totalFiles) {
			return '';
		}

		if (this.remainingCount > 0) {
			const count = this.remainingCount;
			return `Uploading ${count} ${count === 1 ? 'file' : 'files'}`;
		}

		const count = this.uploadedCount;
		return `Uploaded ${count} ${count === 1 ? 'file' : 'files'}`;
	}

	updateBusinessAssociation($event: any, file: FileUploadObject) {
		this.fileBusinessAssociationMap.set(file.id, $event);
	}
}
